import { ProfileRewardAttributes } from '@loyalty/shared-common/profile-api-client';
import { base64Decode } from '@loyalty/shared-common';
import { CampaignAccessToken } from './types';

function unsafeJwtDecode<T = unknown>(token: string): T {
  return JSON.parse(base64Decode(token.split('.')[1]));
}

export function getCampaignRewardToken(
  profileReward: ProfileRewardAttributes,
  locale: string,
): { token: string; tokenPayload: CampaignAccessToken } {
  const codes = profileReward.promocode ? JSON.parse(profileReward.promocode) : undefined;
  const token = codes?.[locale] || codes?.['en'];
  if (!token) {
    throw new Error('No token found for campaign-reward');
  }
  const tokenPayload = unsafeJwtDecode<CampaignAccessToken>(token);
  return { token, tokenPayload };
}
